import React, { useEffect, useRef, useState } from 'react'
import './Slider.css'

const Slider = ({ items = [], delay = 300, pauseOnHover = true }) => {
  const [index, setIndex] = useState(0)
  const intervalRef = useRef(null)
  const isHoveredRef = useRef(false)

  const next = () => setIndex(i => (i + 1) % items.length)
  const prev = () => setIndex(i => (i - 1 + items.length) % items.length)

  const start = () => {
    if (intervalRef.current || items.length <= 1) return
    intervalRef.current = setInterval(() => {
      if (pauseOnHover && isHoveredRef.current) return
      setIndex(i => (i + 1) % items.length)
    }, delay)
  }
  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }
  useEffect(() => {
    start()
    return stop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.length, delay, pauseOnHover])

  useEffect(() => {
    if (index >= items.length) setIndex(0)
  }, [items.length])

  const handleMouseEnter = () => { isHoveredRef.current = true }
  const handleMouseLeave = () => { isHoveredRef.current = false }

  if (!items || items.length === 0) return null
  return (
    <div className="slider-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="slider-viewport">
        <div
          className="slides-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {items.map((item, idx) => (
            <div key={item.id ?? idx} className="slide">
              {item.link ? (
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="slide-link">
                  <img src={item.url} alt={item.title || `Slide ${idx + 1}`} />
                  <div className="slide-text-overlay">
                    <p className="slide-title">{item.title}</p>
                    <p className="slide-location">{item.location}</p>
                  </div>
                </a>
              ) : (
                <>
                  <img src={item.url} alt={item.title || `Slide ${idx + 1}`} />
                  <div className="slide-text-overlay">
                    <p className="slide-title">{item.title}</p>
                    <p className="slide-location">{item.location}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="controls btn-prev">
          <button
            aria-label="Previous"
            onClick={() => { prev(); stop(); }}
            className="control-btn"
          >
            ‹
          </button>
        </div>

        <div className="controls btn-next">
          <button
            aria-label="Next"
            onClick={() => { next(); stop(); }}
            className="control-btn"
          >
            ›
          </button>
        </div>
      </div>

      <div className="indicators">
        {items.map((_, i) => (
          <button
            key={i}
            onClick={() => { setIndex(i); stop(); }}
            aria-label={`Go to slide ${i + 1}`}
            className={i === index ? 'indicator active' : 'indicator'}
          />
        ))}
      </div>
    </div>
  )
}

export default Slider
